import {JSEncrypt} from "jsencrypt";
import CryptoJS from "crypto-js";
import {Base64} from "js-base64";

const privateKeyString =
    "-----BEGIN RSA PRIVATE KEY-----MIIEvQIBADANBgkqhkiG9w0BAQEFAASCBKcwggSjAgEAAoIBAQDVx48rz1c6W0rn4PmpeOBoTcrave8Hv1Xf8H3SWFlc0SYid8u3zXw0ERj3v3h2mvnQ0zAoZQ9pC/syEhuhvIUizS01H6nGs+zutSXgRkAbOW0AIhQBHnMq3TE+lmwgO9U4y0hud6nhx2xXiBGX5dRvHPDmGxS0YMdBafpXsJKdOn6iRJWHNZwDbpYPWg5KcyDdtJhDlyq8TgRJ/lP4SbqBUwmfmLPn4oaRYQgI640AauejCKxknyePyjGYr4YytYY0CxlI++Apd/8jrP11qgppBaPEq4xR6YbImc8dWDpRw7mhiELU5r/2pyfnjhkt0NZHAGzp8y8iROJSwnVjdsGBAgMBAAECggEABlL0zFp669S+UVyCWcUj7BrfsaXeMJ40VdvdlP+q28EAYaFtQ/fAlne4kdz95CBSv6z9A3B1A6LofO37bSp7BY2zf5sXkpcQV95Pbwe/pvWh4MmhSmvZkYz9rf/qZCiboW1sSJxND/W8k5WlDHsgcJvsSYwcwxND1w6ascXyfbbx7pJRCDVCMW585A+PHJF10B/NBD9+pyBbT0RDL/jN5nmeOPD9yueQ0ai3PJXwYruP9QeoHCU+FFDmJsDb5SzFOSuoii+cIlArdvklhtFNnVwskVaBMYWvlKc5cIj1tqj5ZmkfCQ8XFD3hztoM6kCjUw54tm6pvdqamV+Ox1un+wKBgQDrh9+MRqPTDouw0hSeUqy3pqiNe8Js9R7WeaU2PzZEejXhWt0Gr8+EtpuEHCoVZwuNN63XgvZu3QTG7bOsSY4I46x9E+DOidn1312ib+bOdXW03tKQEQfFECabWOHdTRJZc/P00nF58ltumoRHsG4abmgXP2Om7WhwSI01P4YXowKBgQDoW8Lc6xU0n0KWBwlRsqtBLencQAF9EwdU4/Rob+5doOLVQVZ0ZtoQ5m5VvCtGuhNI0rWnOiRQ4XHhSnbebrnaiAcd5ZvuvKY3NuwHIHkXlKJzff+tjtdqCpfxVC93S1Wltx/ID+VAh5zyiKz6GQ2igvnFVpp0R67wnbYz1ackiwKBgBtT5IguGgv/AA5AEcxc41VbrOrdlS13M2DHNHga1X0UgPPoywRfmcBYP6sQaYGaNyjncPA0bctnMYqzQcmXrzcw026fw9GzBOsWQ5L5UNpbnpCh2eSFVVV0DkawBWTb8GkYnxGk6S2xBRLMMtTuj5fZf5JS9IkFurxsbpXjDPfpAoGBANkmAFsze3LdL35D/yqRvkhAn2CNlJaN9PkZvCzqBisME1DXKfPItxy6LP0EyLDlbuZMvSUWSiAoQKQaUjKX6irXm0cOcQbQ2MmbE0OpzmECMDuc0hgh+SEJ22vWkDF9fwJKvHHcoRQIaN2ka3ujdEGfA8uvntLytwP5b/DLR9P3AoGAA+NmN9CG5PTw9S5ekriBSdPWmBR3AQU5iGHZpw+Ex8aCPi1zeTawwDCAVEcdCcUXPWlAqjJ4Kq5tG6Yg3s3exXi6K8i9YdHkP2dcQmWdALGG1wYth5vEUYAcKz7TcdzLf6lygEkaSav+VwfkdnDUWDEmUEVgVWxXeEEJkrNjbNY=-----END RSA PRIVATE KEY-----";
// const publicKeyString =
//     "-----BEGIN PUBLIC KEY-----MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA1cePK89XOltK5+D5qXjgaE3K2r3vB79V3/B90lhZXNEmInfLt818NBEY9794dpr50NMwKGUPaQv7MhIbobyFIs0tNR+pxrPs7rUl4EZAGzltACIUAR5zKt0xPpZsIDvVOMtIbnep4cdsV4gRl+XUbxzw5hsUtGDHQWn6V7CSnTp+okSVhzWcA26WD1oOSnMg3bSYQ5cqvE4ESf5T+Em6gVMJn5iz5+KGkWEICOuNAGrnowisZJ8nj8oxmK+GMrWGNAsZSPvgKXf/I6z9daoKaQWjxKuMUemGyJnPHVg6UcO5oYhC1Oa/9qcn544ZLdDWRwBs6fMvIkTiUsJ1Y3bBgQIDAQAB-----END PUBLIC KEY-----";

const publicKeyString =
    "-----BEGIN PUBLIC KEY-----MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAyHnmINYVkZeY83V8+u1ZHspm3qyEUbHRelRDIb7GppXlDXYkirTQhV6OmI4qimmO3tbnT5HZwk7XbiSw9zRnO4+mMaRDkVsbdDtbFpnDG4f2BhgFFpxd5uO7mZiPVl8Qvkawcpq21BcvZBuooU99cXll1WuoIBwoNq3+E/jTqf9h7x7nsrHtlxJko7hIKV0sH7p2PyIR7iN/wtkRg3dr4AebDL03cGhwqAkCqbJjrPHa2fGwgCgSkG+0SvZSCrDXA523viKIU4qJSCzbFUOV6UaY/Eeb+m0wo2kr2R6AaJffVDH9D/rJVDxJlHMkl7dUxh1dGEyAkoOcNq+awgCZXQIDAQAB-----END PUBLIC KEY-----";

export function rsaEncryptWithPublicKey(str) {
    let encrypt = new JSEncrypt()
    encrypt.setPublicKey(publicKeyString)
    let encrypted = encrypt.encrypt(str)
    return encrypted
}

export function rsaDecryptWithPrivateKey(str) {
    let decrypt = new JSEncrypt()
    decrypt.setPrivateKey(privateKeyString)
    let decrypted = decrypt.decrypt(str)
    return decrypted
}

export function rsaSignWithPrivateKey(str) {
    str = Base64.encode(str)
    let signer = new JSEncrypt()
    signer.setPrivateKey(privateKeyString)
    let sign = signer.sign(str, CryptoJS.SHA256, "sha256")
    return sign
}

/**
 * 使用公钥进行rsa认证
 * @param str{string}
 * @param signStr{string}
 * @returns {boolean}
 */
export function rsaVerifyWithPublicKey(str, signStr) {
    str = Base64.encode(str)
    let signer = new JSEncrypt()
    signer.setPublicKey(publicKeyString)
    let sign = signer.verify(str, signStr, CryptoJS.SHA256)
    return sign
}



// WEBPACK FOOTER //
// ./src/security/RsaHelper.js